// Radio group for choosing how the user defines their project area:
// primary subdivision (county), secondary subdivision (city), or a custom
// uploaded geometry. The internal area-type values ('county'/'city'/'custom')
// are stable; only the labels adapt to the region's vocabulary via settings.
import {
  FormControl, FormLabel, RadioGroup, FormControlLabel, Radio,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setAreaType } from '../store/area-slice.js';
import { selectSettings } from '../store/settings-slice.js';

const capitalize = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);

const AreaTypePicker = () => {
  const dispatch = useDispatch();
  const areaType = useSelector((s) => s.area.areaType);
  const settings = useSelector(selectSettings);

  const options = [
    { value: 'county', label: capitalize(settings.subdivision_primary?.singular || 'county') },
    { value: 'city', label: capitalize(settings.subdivision_secondary?.singular || 'city') },
    { value: 'custom', label: 'Custom (upload boundary files)' },
  ];

  return (
    <FormControl component="fieldset">
      <FormLabel id="area-type-label" component="legend">Select area type</FormLabel>
      <RadioGroup
        row
        aria-labelledby="area-type-label"
        name="area-type"
        value={areaType}
        onChange={(e) => dispatch(setAreaType(e.target.value))}
      >
        {options.map((opt) => (
          <FormControlLabel
            key={opt.value}
            value={opt.value}
            control={<Radio />}
            label={opt.label}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default AreaTypePicker;
